import React from "react";
import "./FiltroServico.css";

const SERVICOS = [
  "Auditoria",
  "Audit. Patrimonial",
  "Governança",
  "Guarda Documental",
  "Planejamento Estratégico",
];

const FiltroServico = ({ valorSelecionado, onChange }) => {
  return (
    <div className="filtro-servico-container">
      <div className="filtro-botoes">
        {SERVICOS.map((servico) => (
          <button
            key={servico}
            type="button"
            className={`filtro-botao ${
              valorSelecionado === servico ? "ativo" : ""
            }`}
            onClick={() =>
              valorSelecionado === servico
                ? onChange(null)   // remove filtro
                : onChange(servico)
            }
          >
            {servico}
          </button>
        ))}
      </div>
    </div>
  );
};

export default FiltroServico;